<template>
    <div class="header">
        <div class="main-data">
            <div class="left">
                <div class="title">{{title}}<span class="hint-mess">{{this.title === '北向资金' ? unit1 : unit2}}</span> </div>
                <div class="name">净买入:</div>
                <div :class="{'up':data.jmr > 0, 'down': data.jmr< 0, 'grey': data.jmr == 0 , 'data': true }">
                     {{data.jmr | showNumWithUnit()}}
                </div>
                <div class="name">净流入: </div>
                <div :class="{'up':data.jlr > 0, 'down': data.jlr< 0, 'grey': data.jlr == 0, 'data': true }">
                    {{data.jlr | showNumWithUnit()}}
                </div>
                <div class="tips">
                    <tips :text="'净买入 = 买入成交额 - 卖出成交额 <br/> 净流入 = 当日限额 - 当日余额  <br/>净流入包含成交净买额和申报未成交两部分'" :width="'270px'"></tips>
                </div>
            </div>
            <div class="right">
                <div class="name">数据日期: </div>
                <div class="time">{{ data.market_value.now_date || '--' }}</div>
                <div class="status">{{ data.h.state }}</div>
            </div>
        </div>
        <div class="detail-data">
            <div class="detail-box">
                <div class="name">
                    {{ name1 }}
                </div>
                <div class="data-box">
                    <div class="data-line">
                        <ul class="data-item rb-border">
                            <li class="data-item-name">净买入</li>
                            <li :class="{'up': data.h.net_turnover > 0, 'down': data.h.net_turnover < 0, 'grey': data.h.net_turnover == 0, 'big-font': true}">
                                {{ data.h.net_turnover | showNumWithUnit()}}
                            </li>
                        </ul>
                        <ul class="data-item rb-border">
                            <li class="data-item-name">买入</li>
                            <li class="data-item-data">{{ data.h.buy_turnover | showNumWithUnit() }}</li>
                        </ul>
                        <ul class="data-item rb-border">
                            <li class="data-item-name">卖出</li>
                            <li class="data-item-data">{{ data.h.sell_turnover | showNumWithUnit()}}</li>
                        </ul>
                    </div>
                    <div class="data-line">
                        <ul class="data-item r-border">
                            <li class="data-item-name"> 净流入</li>
                            <li :class="{'up': data.h.zjlr > 0, 'down': data.h.zjlr <= 0, 'grey': data.h.zjlr == 0, 'big-font': true}">{{ data.h.zjlr | showNumWithUnit()}}</li>
                        </ul>
                        <ul class="data-item r-border">
                            <li class="data-item-name">当日余额</li>
                            <li class="data-item-data">{{ data.h.syed | showNumWithUnit()}}</li>
                        </ul>
                        <ul class="data-item r-border">
                            <li class="data-item-name">当日额度</li>
                            <li class="data-item-data">{{ data.h.zed | showNumWithUnit(0)}}</li>
                        </ul>
                    </div>
                </div>
                <div class="simple-column">
                    <simple-column v-if="data.h.up" :up="data.h.up" :equal="data.h.mid" :down="data.h.down" />
                </div>
            </div>
            <div class="detail-box">
                <div class="name">
                    {{ name2 }}
                </div>
                <div class="data-box">
                    <div class="data-line">
                        <ul class="data-item rb-border">
                            <li class="data-item-name">净买入</li>
                            <li :class="{'up': data.s.net_turnover > 0, 'down': data.s.net_turnover <= 0, 'grey': data.s.net_turnover == 0,  'big-font': true}">{{ data.s.net_turnover | showNumWithUnit() }}</li>
                        </ul>
                        <ul class="data-item rb-border">
                            <li class="data-item-name">买入</li>
                            <li class="data-item-data">{{ data.s.buy_turnover | showNumWithUnit() }}</li>
                        </ul>
                        <ul class="data-item rb-border">
                            <li class="data-item-name">卖出</li>
                            <li class="data-item-data">{{ data.s.sell_turnover | showNumWithUnit()}}</li>
                        </ul>
                    </div>
                    <div class="data-line">
                        <ul class="data-item r-border">
                            <li class="data-item-name">净流入</li>
                            <li :class="{'up': data.s.zjlr > 0, 'down': data.s.zjlr <= 0, 'grey': data.s.zjlr == 0, 'big-font': true}">{{ data.s.zjlr | showNumWithUnit() }}</li>
                        </ul>
                        <ul class="data-item r-border">
                            <li class="data-item-name">当日余额</li>
                            <li class="data-item-data">{{ data.s.syed | showNumWithUnit()}}</li>
                        </ul>
                        <ul class="data-item r-border">
                            <li class="data-item-name">当日额度</li>
                            <li class="data-item-data">{{ data.s.zed | showNumWithUnit(0)}}</li>
                        </ul>
                    </div>
                </div>
                <div class="simple-column">
                    <simple-column v-if="data.s.up" :up="data.s.up" :equal="data.s.mid" :down="data.s.down" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import simpleColumn from './simpleColumn'
import tips from './tips'
export default {
    props: {
        title: String, // 圆圈内标题
        data: Object        
    },
    data () {
        return {
            name1: '沪股通',
            name2: '深股通',
            unit1: '(人民币)',
            unit2: '(港币)'
        }
    },
    mounted() {
        this.name1 = this.title === '北向资金' ? '沪股通' : '港股通(沪)'
        this.name2 = this.title === '北向资金' ? '深股通' : '港股通(深)'
    },
    components: {
        simpleColumn,
        tips
    },
    filters:{
        showNumWithUnit(val, byte = 2){
            if(isNaN(parseInt(val))){
                return '--';
            }
            return Number(val).toFixed(byte) + '亿';
        }
    }
}
</script>
<style lang="less">
@import './index.less';
</style>